import { useEffect, useRef } from 'react'

export const useTextareaAutoResize = (value: string, minHeight = 200, maxHeight = 540) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    const textarea = textareaRef.current
    if (!textarea) return

    textarea.style.height = 'auto'
    textarea.style.minHeight = 'auto'
    textarea.style.maxHeight = 'none'

    const scrollHeight = textarea.scrollHeight
    let newHeight = Math.max(scrollHeight, minHeight)

    if (newHeight > maxHeight) {
      newHeight = maxHeight
      textarea.style.overflowY = 'auto'
    } else {
      textarea.style.overflowY = 'hidden'
    }

    textarea.style.minHeight = `${minHeight}px`
    textarea.style.maxHeight = `${maxHeight}px`
    textarea.style.height = `${newHeight}px`
  }, [value, minHeight, maxHeight])

  return textareaRef
}
